const ZERO_KILOMETER = 0;
const ONE_KILOMETER = 1;
const TEN_KILOMETER = 10;
const THIRTY_KILOMETER = 30;
const FIFTY_KILOMETER = 50;
const NINETY_NINE_KILOMETER = 99;
export default {
    ZERO_KILOMETER,
    ONE_KILOMETER,
    TEN_KILOMETER,
    THIRTY_KILOMETER,
    FIFTY_KILOMETER,
    NINETY_NINE_KILOMETER,
};
